import { render, staticRenderFns } from "./GClickIntegrationTab.vue?vue&type=template&id=4a7e805a"
import script from "./GClickIntegrationTab.vue?vue&type=script&lang=js"
export * from "./GClickIntegrationTab.vue?vue&type=script&lang=js"
import style0 from "./GClickIntegrationTab.vue?vue&type=style&index=0&id=4a7e805a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports